import api from "../../../utils/api";

import { RequestParams } from "../../../utils/RequestParams";

import { httpRequest } from "../../../../shared/superagent";

const get = async (
params,
headers) =>
{
  const requestParams = new RequestParams(params, headers);
  const response = await api.get('dictionaries', requestParams);


  return response.json.rows;
};

const save = async (
thesaurus) =>
{
  const requestParams = new RequestParams(thesaurus);
  const response = await api.post('thesauris', requestParams);


  return response.json;
};

const deleteThesauri = async (params) => {
  const requestParams = new RequestParams(params);
  const response = await api.delete('thesauris', requestParams);
  return response.json;
};

const importThesaurus = async (
thesaurus,
file) =>
{
  const headers = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };
  const fields = {
    thesauri: JSON.stringify(thesaurus)
  };
  return httpRequest('thesauris', fields, headers, file);
};

export { get, save, deleteThesauri, importThesaurus };